import React from "react";
import FilterRadioButtons from "../forms/filter-radio-buttons";
import {  alertStatuses, channel_values, filterByAudit } from "../helper-components/data";
import { filterByTimePeriod } from "../helper-components/data";

const AlertFilter = ({ setFilterData, filterData }) => {
  const handlePerodicChange = (e) => {
    setFilterData({
      ...filterData,
      channel_values: e.target.value,
    });
    
  };
  const handleAuditChange = (e) => {
    setFilterData({
      ...filterData,
      status: e.target.value,
    });
    
  };
  return (
    <div
      menuPortalTarget={document.body}
      style={{
        minWidth: "17rem",
        zIndex: 999,
        top: "40px",
        right: "-5px",
        boxShadow: `0 12px 32px -8px var(--popover-shadow-color), 0 2px 6px -2px var(--popover-shadow-color)`,
      }}
      className="absolute  border border-[var(--popover-border-color)] border-solid border-1   py-3 px-2  bg-[var(--popover-bg-color)]  rounded-xl z-10 flex flex-col"
    >
      <span className="px-3 pt-1.5 pb-2.5 text-sm fw_600 text-[var(--popover-heading-fg-color)]">
        Filter by
      </span>
      <hr className="border-0 border-t border-[var(--popover-border-color)] -mx-2" />
      <div className="px-3 flex flex-row gap-6">
        
        <FilterRadioButtons
          name="channel_values"
          label={"Channels"}
          options={channel_values}
          handleChange={handlePerodicChange}
          value={filterData?.channel_values}
        />
        
        <FilterRadioButtons
          name="status"
          label={"Status"}
          options={alertStatuses}
          handleChange={handleAuditChange}
          value={filterData?.status}
        />
      </div>
    </div>
  );
};

export default AlertFilter;
